import LocalImages from "assets/images/local-images";
import ProcessingAnimation from "features/shared/styles/ProcessingAnimation.styled";
import { MicroHeader } from "features/shared/styles/typography/MicroHeader.styled";
import { FC } from "react";

import LoaderContainer from "./styles/LoaderContainer.styled";

// TODO move to config
const clientsWithLogo = ["BA"];
const clientsWithGifLoader = ["DEFAULT", "VOLARIS", "VIVA", "VIVA_LUCY", "JETBLUE"];

interface LoaderProps {
  title: string;
}

const Loader: FC<LoaderProps> = ({ title }) => {
  const hasLogo = clientsWithLogo.includes(process.env.REACT_APP_CLIENT || "");
  const hasGifLoader = clientsWithGifLoader.includes(
    process.env.REACT_APP_CLIENT || ""
  );

  return (
    <LoaderContainer>
      {hasLogo ? (
        <img
          className="airline-logo"
          alt="airline logo"
          src={LocalImages.shared.images.airlineLogoMobile}
        />
      ) : null}
      <MicroHeader>{title}</MicroHeader>
      {hasGifLoader ? (
        <img
          className="loader-animation"
          alt="loader animation"
          src={LocalImages.shared.images.loaderAnimation}
        />
      ) : (
        <ProcessingAnimation />
      )}
    </LoaderContainer>
  );
};

export default Loader;